import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';
import auth, { authSaga } from './auth';
import comCode, { comCodeSaga } from './comCode';
import partnerModule, { partnerModuleSaga } from './partnerModule';
import productModule, { productModuleSaga } from './productModule';
import chanceModule, { chanceModuleSaga } from './chanceModule';
import userModule, { userModuleSaga } from './userModule';
import empModule, { empModuleSaga } from './empModule';
import projectModule, { projectModuleSaga } from './projectModule';
import taxbillModule, { taxbillModuleSaga } from './taxbillModule';
import taxIssuedModule, { taxIssuedModuleSaga } from './taxIssuedModule';
import payModule, { payModuleSaga } from './payModule';
import techModule, { techModuleSaga } from './techModule';
import departModule, { departModuleSaga } from './deptModule';
import noticeModule, { noticeModuleSaga } from './noticeModule';
import staticsModule, { staticsModuleSaga } from './staticsModule';
import inventoryModule, { inventoryModuleSaga } from './inventoryModule';
import approvalModule, { approvalModuleSaga } from './approvalModule';
import dashboardModule, { dashboardModuleSaga } from './dashboardModule/index';
import salesCostModule, { salesCostModuleSaga } from './salesCostModule/index';

import loading from './loading';

const rootReducer = combineReducers({
  auth,
  loading,
  comCode,
  dashboardModule,
  approvalModule,
  partnerModule,
  productModule,
  chanceModule,
  userModule,
  empModule,
  projectModule,
  taxbillModule,
  taxIssuedModule,
  payModule,
  techModule,
  departModule,
  noticeModule,
  staticsModule,
  inventoryModule,
  salesCostModule,
});

export function* rootSaga() {
  yield all([
    authSaga(),
    comCodeSaga(),
    dashboardModuleSaga(),
    approvalModuleSaga(),
    partnerModuleSaga(),
    productModuleSaga(),
    chanceModuleSaga(),
    userModuleSaga(),
    empModuleSaga(),
    projectModuleSaga(),
    taxbillModuleSaga(),
    taxIssuedModuleSaga(),
    payModuleSaga(),
    techModuleSaga(),
    departModuleSaga(),
    noticeModuleSaga(),
    staticsModuleSaga(),
    inventoryModuleSaga(),
    salesCostModuleSaga(),
  ]);
}

export default rootReducer;
